
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dumpster-rental",
      function () {
        return require("private-next-pages/dumpster-rental/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dumpster-rental"])
      });
    }
  